<template>
  <div class="contact-bd">
    <div class="contact-wrap tab-content">
      <div class="table-bd">
        <div class="contact-title" style="margin:16px 0px;" v-if="funcView.partner_detail_add_contact">
          <el-button type="primary" icon="el-icon-plus" @click="addContact()">{{$t('crm_renter_detail_contact.xin_zeng_lian_xi_ren')}}</el-button>
        </div>
        <custom-table
          :data="coopcontactList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
           :slots="['action']"
        >
          <!-- 操作列 -->
          <template slot="action" slot-scope="scope">
            <el-button
              type="text"
              size="mini"
              v-if="funcView.partner_detail_edit_contact"
              @click="editContact(scope.row)"
            >{{$t('Common.com_edit')}}</el-button>
            <el-button
              type="text"
              size="mini"
              v-if="funcView.partner_detail_delete_contact"
              @click="deleteContact(scope.row.contactId)"
            >{{$t('Common.com_delete')}}
            </el-button>
            </template>
        </custom-table>
        <div class="contact-title" style="margin:16px 0px;" v-if="funcView.partner_detail_add_busleader">
          <el-button type="primary" icon="el-icon-plus"  @click="addContactBusleader()">{{$t('crm_renter_detail_contact.xzxmfzr')}}</el-button>
        </div>
        <div class="title" v-if="busleaderList.length">{{$t('crm_renter_detail_contact.xmfzrxx')}}</div>
        <custom-table
          :data="busleaderList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['post','action']"
        >
          <template v-slot:post="">
            <span>{{$t('crm_renter_detail_contact.xiang_mu_fu_ze_ren')}}</span>
          </template>
          <!-- 操作列 -->
          <template slot="action" slot-scope="scope">
              <span></span>
              <el-button
                type="text"
                size="mini"
                v-if="funcView.partner_detail_edit_busleader"
                @click="editContactBusleader(scope.row)"
              >{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="funcView.partner_detail_delete_busleader"
                @click="deleteContactBusleader(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
            </template>
        </custom-table>
        <div class="contact-title" style="margin:16px 0px;" v-if="funcView.partner_detail_add_financer">
          <el-button type="primary" icon="el-icon-plus" v-if="!financerList.length" @click="addContactFinancer()">{{$t('crm_renter_detail_contact.xzcwfzr')}}</el-button>
        </div>
       <div class="title" v-if="financerList.length">{{$t('crm_renter_detail_contact.cwfzrxx')}}</div>
        <custom-table
          :data="financerList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['post','action']"
        >
          <template v-slot:post="">
            <span>{{$t('crm_renter_detail_contact.cai_wu_fu_ze_ren')}}</span>
          </template>
          <!-- 操作列 -->
           <template slot="action" slot-scope="scope">
              <span></span>
              <el-button
                type="text"
                size="mini"
                v-if="funcView.partner_detail_edit_financer"
                @click="editContactFinancer(scope.row)"
              >{{$t('Common.com_edit')}}</el-button>
              <el-button
                type="text"
                size="mini"
                v-if="funcView.partner_detail_delete_financer"
                @click="deleteContactFinancer(scope.row.contactId)"
              >{{$t('Common.com_delete')}}</el-button>
            </template>
        </custom-table>
      </div>
    </div>

    <renter-contacts-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getContactList"
    >
    </renter-contacts-dialog>
    <renter-contactsBusiness-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
      @success="getContactList"
    >
    </renter-contactsBusiness-dialog>
    <renter-contactsFinance-dialog
      v-if="dialogVisible2"
      :model="dialogModel2"
      @close="dialogVisible2 = false"
      @success="getContactList"
    >
    </renter-contactsFinance-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import renterContactsDialog from './renter_contacts_dialog.vue';
import renterContactsBusinessDialog from './renter_contactsBusiness_dialog.vue';
import renterContactsFinanceDialog from './renter_contactsFinance_dialog.vue';

export default {
  components: {
    renterContactsDialog,
    renterContactsBusinessDialog,
    renterContactsFinanceDialog
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String,
    partnerOrgId: String,
  },
  data() {
    return {
      tableCode: 'company_contact',
      // 合同类型
      // 操作
      visibleSet: '',
      dialogSetData: {},
      contactList: [],
      coopcontactList: [],
      busleaderList: [],
      financerList: [],
      // 联系人弹窗
      dialogVisible: false,
      dialogModel: {},
      // 业务联系人弹窗
      dialogVisible1: false,
      dialogModel1: {},
      // 财务联系人弹窗
      dialogVisible2: false,
      dialogModel2: {},
    };
  },

  mounted() {
    this.getTableColumn();
    this.getFuncView('/customer/renterDetail');
    this.getContactList();
  },

  methods: {
    getContactList: function () {
      if (!this.partnerId) {
        return;
      }

      this.$getJSON(apis.partnerContact, {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      }).then((res) => {
        this.contactList = res.data || [];
        // contactType: 'coopcontact'
        this.coopcontactList = this.contactList.filter(i => i.contactType === 'coopcontact');
        this.busleaderList = this.contactList.filter(i => i.contactType === 'busleader');
        this.financerList = this.contactList.filter(i => i.contactType === 'financer');

      });
    },

    // 新增联系人
    addContact() {
      const title = this.$t('crm_renter_detail_contact.xin_zeng_lian_xi_ren');
      this.dialogModel.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel.title = title;
      this.dialogModel.type = 'add';
      this.dialogVisible = true;
      // this.getPartnerContact()
    },
    // 编辑联系人
    editContact(item) {
      const title = this.$t('crm_renter_detail_contact.bian_ji_lian_xi_ren');
      this.dialogModel.data = item;
      this.dialogModel.title = title;
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
      // this.getPartnerContact()
    },
    deleteContact: function (contactId) {
      const tips = this.$t('crm_renter_detail_contact.nqdysclxrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
    // 新增业务员
    addContactBusleader() {
      const title = this.$t('crm_renter_detail_contact.xzxmfzr');
      this.dialogModel1.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'add';
      this.dialogVisible1 = true;
      // this.getPartnerContact()
    },
    // 编辑业务员
    editContactBusleader(item) {
      const title = this.$t('crm_renter_detail_contact.bjxmfzr');
      this.dialogModel1.data = item;
      this.dialogModel1.title = title;
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
      // this.getPartnerContact()
    },
    deleteContactBusleader: function (contactId) {
      const tips = this.$t('crm_renter_detail_contact.nqdyscxmfzrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
    // 新增财务
    addContactFinancer() {
      const title = this.$t('crm_renter_detail_contact.xzcwfzr');
      this.dialogModel2.data = {
        partnerId: this.partnerId,
        partnerOrgId: this.partnerOrgId
      };
      this.dialogModel2.title = title;
      this.dialogModel2.type = 'add';
      this.dialogVisible2 = true;
      // this.getPartnerContact()
    },
    // 编辑财务
    editContactFinancer(item) {
      const title = this.$t('crm_renter_detail_contact.bjcwfzr');
      this.dialogModel2.data = item;
      this.dialogModel2.title = title;
      this.dialogModel2.type = 'edit';
      this.dialogVisible2 = true;
      // this.getPartnerContact()
    },
    deleteContactFinancer: function (contactId) {
      const tips = this.$t('crm_renter_detail_contact.nqdysccwfzrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.partnerContactDelete}/${contactId}`,).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.getContactList();
          });
        })
        .catch(() => {});
    },
  }
};
</script>

<style lang="scss">
@import "style/colors.scss";
.contact-bd {
  // height: 100%;
  display: flex;
  flex-direction: column;
  .contact-wrap {
    flex: 1;
    // height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    // padding-left: 40px;
    // padding-right: 24px;
    background-color: #ffffff;
    .morebtn {
      color: $main-color;
    }
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin: 24px 0;
      font-size: 12px;
    }
  }
}
</style>
